import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = ({ onSuccess, onClose }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${API}/auth/login`, { password });
      if (response.data.success) {
        onSuccess(password);
      }
    } catch (err) {
      setError('Contraseña incorrecta');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{color: '#0055A4', margin: 0}}>🔐 Acceso Administrador</h2>
          <button className="modal-close" onClick={onClose} data-testid="modal-close-btn">
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}
          
          <label htmlFor="admin-password">Contraseña:</label>
          <input
            id="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Ingrese la contraseña de administrador"
            data-testid="admin-password-input"
            autoFocus
          />
          
          <button type="submit" className="primary" style={{ width: '100%' }} data-testid="admin-login-submit-btn">
            🔑 Ingresar como Admin
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;